// Общий контроллер попапов: те же data-атрибуты, что у PopupNew на основном сайте
export class Popup {
	constructor() {
		this.activePopup = null
		this.trigger = null
		this.wasLocked = false
		this.closing = false
		this.closeCleanup = null
		this.escapeHandled = false

		document.querySelectorAll('dialog[data-popup-name]').forEach((popup) => {
			let pressedOutside = false

			popup.addEventListener('pointerdown', (e) => {
				pressedOutside = !e.target.closest('.popup__card, .tooltip')
			})

			popup.addEventListener('click', (e) => {
				if (e.target.closest('a[href="#"]')) e.preventDefault()
				if (pressedOutside && !e.target.closest('.popup__card, .tooltip')) this.close(popup)
				pressedOutside = false
			})

			popup.addEventListener('cancel', (e) => {
				e.preventDefault()
				this.close(popup)
			})

			popup.addEventListener('close', () => {
				if (this.activePopup !== popup) return

				if (this.closeCleanup) this.closeCleanup()
				this.closing = false
				popup.classList.remove('active')
				document.body.classList.toggle('no-scroll', this.wasLocked)
				this.activePopup = null
				if (this.trigger && this.trigger.isConnected) this.trigger.focus({ preventScroll: true })
				this.trigger = null

				popup.dispatchEvent(new CustomEvent('popup:close', { bubbles: true }))
			})
		})

		document.addEventListener('click', (e) => {
			const trigger = e.target.closest('[data-popup-open]')
			if (trigger) {
				const name = trigger.getAttribute('data-popup-open')
				const popup = document.querySelector(`dialog[data-popup-name="${CSS.escape(name)}"]`)
				if (!popup || this.activePopup) return

				e.preventDefault()
				this.open(popup, trigger)
				return
			}

			const close = e.target.closest('[data-popup-close]')
			if (close) {
				const popup = close.closest('dialog[data-popup-name]')
				if (popup && popup.open) {
					e.preventDefault()
					this.close(popup)
				}
			}
		})

		window.addEventListener('keydown', (e) => {
			if (e.key !== 'Escape' || !this.activePopup) return

			e.preventDefault()
			e.stopImmediatePropagation()
			this.escapeHandled = true
			this.close(this.activePopup)
		}, true)

		window.addEventListener('keyup', (e) => {
			if (e.key !== 'Escape' || !this.escapeHandled) return

			e.preventDefault()
			e.stopImmediatePropagation()
			this.escapeHandled = false
		}, true)
	}

	open(popup, trigger) {
		if (popup.dataset.popupName === 'class' && trigger)
			this.fillClassPopup(popup, trigger)

		popup.dispatchEvent(new CustomEvent('popup:open', { bubbles: true, detail: { trigger } }))
		this.trigger = trigger
		this.wasLocked = document.body.classList.contains('no-scroll')
		this.activePopup = popup
		popup.showModal()
		document.body.classList.add('no-scroll')
		const scroller = popup.querySelector('[data-popup-scroll]') || popup.querySelector('.popup__wrapper')
		scroller.scrollTop = 0

		// Фиксируем начальное состояние перед запуском перехода
		popup.getBoundingClientRect()
		popup.classList.add('active')
		popup.querySelector('.popup__card').focus({ preventScroll: true })
		popup.dispatchEvent(new CustomEvent('popup:ready', { bubbles: true }))
	}

	/** Контент попапа класса — из data-/скрытого описания у кнопки-триггера */
	fillClassPopup(popup, trigger) {
		const num = trigger.getAttribute('data-class-id') || ''
		const nameEl = trigger.querySelector('.format__class-name')
		const iconEl = trigger.querySelector('.format__class-icon svg')
		const item = trigger.closest('.format__classes-item') || trigger
		const descEl = item.querySelector('.format__class-desc')

		const numNode = popup.querySelector('.popup-class__num')
		const titleNode = popup.querySelector('.popup-class__title')
		const iconNode = popup.querySelector('.popup-class__icon')
		const contentNode = popup.querySelector('.popup-class__content .text-block')

		if (numNode) {
			numNode.textContent = trigger.dataset.classLabel || (num ? 'Аудиторный класс' : '')
			numNode.hidden = !numNode.textContent
		}
		if (titleNode) {
			if (trigger.dataset.classTitle) titleNode.textContent = trigger.dataset.classTitle
			else titleNode.innerHTML = nameEl ? nameEl.innerHTML : ''
		}
		if (iconNode) {
			iconNode.replaceChildren()
			if (iconEl) {
				const clone = iconEl.cloneNode(true)
				// Ссылки на clipPath внутри копии не должны указывать на иконку в карточке
				clone.querySelectorAll('[id]').forEach((element) => {
					const id = element.id
					element.id = `popup-class-${id}`
					clone.querySelectorAll('[clip-path]').forEach((clipped) => {
						if (clipped.getAttribute('clip-path') === `url(#${id})`) clipped.setAttribute('clip-path', `url(#${element.id})`)
					})
				})
				iconNode.appendChild(clone)
			}
		}
		if (contentNode)
			contentNode.innerHTML = descEl ? descEl.innerHTML : ''
	}

	close(popup) {
		if (this.activePopup !== popup || this.closing) return
		this.closing = true
		popup.classList.remove('active')

		const style = getComputedStyle(popup)
		const toMilliseconds = (value) => parseFloat(value) * (value.trim().endsWith('ms') ? 1 : 1000)
		const durations = style.transitionDuration.split(',').map(toMilliseconds)
		const delays = style.transitionDelay.split(',').map(toMilliseconds)
		const duration = Math.max(...durations.map((value, index) => value + delays[index % delays.length]))

		if (!duration) {
			popup.close()
			return
		}

		const finish = () => {
			this.closeCleanup()
			if (popup.open) popup.close()
		}
		const onTransitionEnd = (e) => {
			if (e.target === popup && e.propertyName === 'opacity' && !e.pseudoElement) finish()
		}
		const timer = window.setTimeout(finish, duration + 50)

		this.closeCleanup = () => {
			window.clearTimeout(timer)
			popup.removeEventListener('transitionend', onTransitionEnd)
			this.closeCleanup = null
		}
		popup.addEventListener('transitionend', onTransitionEnd)
	}
}
